import { render, staticRenderFns } from "./social-share-item.vue?vue&type=template&id=f479121c"
import script from "./social-share-item.vue?vue&type=script&lang=js"
export * from "./social-share-item.vue?vue&type=script&lang=js"
import style0 from "./social-share-item.vue?vue&type=style&index=0&id=f479121c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports